import { render, staticRenderFns } from "./mainRule.vue?vue&type=template&id=7381ba9a&scoped=true&"
import script from "./mainRule.vue?vue&type=script&lang=js&"
export * from "./mainRule.vue?vue&type=script&lang=js&"
import style0 from "./mainRule.vue?vue&type=style&index=0&id=7381ba9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381ba9a",
  null
  
)

export default component.exports